module.exports = __webpack_public_path__ + "static/img/1808_3.6a6ac8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1808_3.jpg
// module id = BZ3y
// module chunks = 1